import { __awaiter } from "tslib";
import { messagingStore, userSettingsStore } from '@/store/store';
import Mds from '@mcf/design-system';
import { FeatureFailReason, Logger, ServiceMessagingBase, ServiceNotification, ServiceProvider, UICore, } from '@mcf/ui-core';
import { kebabCase } from 'lodash';
class MessagingService extends ServiceMessagingBase {
    onVisibilityChanged(messageData) {
        return __awaiter(this, void 0, void 0, function* () {
            messagingStore.setVisibility(messageData.options.visibility);
        });
    }
    onChangeTheme(messageData) {
        return __awaiter(this, void 0, void 0, function* () {
            // WARNING: dark theme may not be fully supported by MDS components
            // used in application, please make sure to always test light and dark
            // variant of your application with every change or disable this support
            Mds.setTheme(messageData.options.theme);
        });
    }
    onInvokeFeature(messageData) {
        const logger = new Logger(`[${kebabCase(UICore.instance.projectCode)}][messaging]`);
        logger.warn('There is no support for other features', messageData);
        return Promise.resolve({
            event: ServiceNotification.invokeFeatureFailed,
            isResponseAwaited: false,
            messageId: messageData.messageId,
            messageKey: messageData.messageKey,
            options: {
                customData: Object.assign(Object.assign({}, messageData.options.customData), { reason: FeatureFailReason.Other, reasonMessage: 'support for invoke-feature request in connect-settings is missing' }),
                feature: messageData.options.feature,
                filters: messageData.options.filters,
            },
        });
    }
    onSignUserOut(messageData) {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                yield UICore.destroy();
                return {
                    event: ServiceNotification.userSignedOut,
                    isResponseAwaited: false,
                    messageId: messageData.messageId,
                    messageKey: messageData.messageKey,
                };
            }
            catch (error) {
                throw new Error('Cannot invalidate token', error);
            }
        });
    }
    onUserDetailsChanged(messageData) {
        return __awaiter(this, void 0, void 0, function* () {
            yield userSettingsStore.setUserDetails(messageData.options);
        });
    }
}
export const messagingServiceProvider = new ServiceProvider(MessagingService);
